import { notification } from 'antd';
import { useUpdatePolygonGeometryMutation } from 'app/api';
import { selectEditFieldData } from 'app/containers/Field/slice/selectors';
import {
  IUploadPolygonData,
  PolygonLatLngTupleType,
} from 'app/containers/Field/slice/types';
import { selectSelectedEnvId } from 'app/containers/HiikoEnv/slice/selectors';
import { selectSelectedSeasonId } from 'app/containers/Season/slice/selectors';
import { RouteConstants } from 'app/routes';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { generatePath, useHistory } from 'react-router-dom';
import * as L from 'leaflet';
import { handleError } from 'app/containers/Global/slice/helpers';

const useOnUpdatedGeometryFieldSubmit = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const [updatePolygonGeometry] = useUpdatePolygonGeometryMutation();
  const envId = useSelector(selectSelectedEnvId) as number;
  const seasonId = useSelector(selectSelectedSeasonId);

  const {
    name,
    fieldId,
    companyId: fieldCompanyId,
    seasonId: fieldSeasonId,
    latlngs,
  } = useSelector(selectEditFieldData);

  const onSubmit = async () => {
    try {
      if (
        fieldCompanyId &&
        seasonId &&
        fieldId &&
        fieldSeasonId &&
        name &&
        envId
      ) {
        const polygonGeoJSON = L.polygon(latlngs as any)?.toGeoJSON();
        const coordinatesFromGeoJSON = ([
          polygonGeoJSON.geometry.coordinates,
        ] as unknown) as PolygonLatLngTupleType;

        const data: IUploadPolygonData = {
          geometryInfo: {
            type: 'MULTIPOLYGON',
            coordinates: coordinatesFromGeoJSON,
          },
          fieldName: name,
          companyId: fieldCompanyId,
          seasonId: fieldSeasonId,
        };

        await updatePolygonGeometry({ envId, fieldId, data }).unwrap();

        notification.success({
          message: t(
            'Field.Notification.FieldEdited',
            'Field successfully edited.',
          ),
          placement: 'bottomRight',
        });

        history.push(
          generatePath(RouteConstants.field.details, {
            envId,
            fieldId,
          }),
        );
      }
    } catch (error) {
      if (error?.status !== 500) {
        handleError(error);
      }
    }
  };

  return { onSubmit };
};

export default useOnUpdatedGeometryFieldSubmit;
